/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddQuestionnaireConfigDto,
  QuestionnaireConfigItemDto,
  UpdateQuestionnaireConfigDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Add a questionnaire config to a nursery
 */
export const addQuestionnaireConfigCommandControllerAddConfig = (
  nurseryId: string,
  addQuestionnaireConfigDto: AddQuestionnaireConfigDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/questionnaire-configs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addQuestionnaireConfigDto,
    signal,
  });
};

export const getAddQuestionnaireConfigCommandControllerAddConfigMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>
      >,
      TError,
      { nurseryId: string; data: AddQuestionnaireConfigDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>
    >,
    TError,
    { nurseryId: string; data: AddQuestionnaireConfigDto },
    TContext
  > => {
    const mutationKey = ["addQuestionnaireConfigCommandControllerAddConfig"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>
      >,
      { nurseryId: string; data: AddQuestionnaireConfigDto }
    > = (props) => {
      const { nurseryId, data } = props ?? {};

      return addQuestionnaireConfigCommandControllerAddConfig(nurseryId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddQuestionnaireConfigCommandControllerAddConfigMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>>
  >;
export type AddQuestionnaireConfigCommandControllerAddConfigMutationBody =
  AddQuestionnaireConfigDto;
export type AddQuestionnaireConfigCommandControllerAddConfigMutationError =
  unknown;

/**
 * @summary Add a questionnaire config to a nursery
 */
export const useAddQuestionnaireConfigCommandControllerAddConfig = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>
      >,
      TError,
      { nurseryId: string; data: AddQuestionnaireConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addQuestionnaireConfigCommandControllerAddConfig>>,
  TError,
  { nurseryId: string; data: AddQuestionnaireConfigDto },
  TContext
> => {
  return useMutation(
    getAddQuestionnaireConfigCommandControllerAddConfigMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List questionnaire configs for a nursery
 */
export const listQuestionnaireConfigsQueryControllerListConfigs = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<QuestionnaireConfigItemDto[]>({
    url: `/v1/nurseries/${nurseryId}/questionnaire-configs`,
    method: "GET",
    signal,
  });
};

export const getListQuestionnaireConfigsQueryControllerListConfigsQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/questionnaire-configs`] as const;
};

export const getListQuestionnaireConfigsQueryControllerListConfigsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
    >,
    TError = unknown,
  >(
    nurseryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listQuestionnaireConfigsQueryControllerListConfigs
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListQuestionnaireConfigsQueryControllerListConfigsQueryKey(nurseryId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
      >
    > = ({ signal }) =>
      listQuestionnaireConfigsQueryControllerListConfigs(nurseryId, signal);

    return {
      queryKey,
      queryFn,
      enabled: nurseryId !== null && nurseryId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListQuestionnaireConfigsQueryControllerListConfigsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
    >
  >;
export type ListQuestionnaireConfigsQueryControllerListConfigsQueryError =
  unknown;

export function useListQuestionnaireConfigsQueryControllerListConfigs<
  TData = Awaited<
    ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
  >,
  TError = unknown,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listQuestionnaireConfigsQueryControllerListConfigs
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listQuestionnaireConfigsQueryControllerListConfigs
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListQuestionnaireConfigsQueryControllerListConfigs<
  TData = Awaited<
    ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
  >,
  TError = unknown,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listQuestionnaireConfigsQueryControllerListConfigs
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listQuestionnaireConfigsQueryControllerListConfigs
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListQuestionnaireConfigsQueryControllerListConfigs<
  TData = Awaited<
    ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
  >,
  TError = unknown,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List questionnaire configs for a nursery
 */

export function useListQuestionnaireConfigsQueryControllerListConfigs<
  TData = Awaited<
    ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
  >,
  TError = unknown,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listQuestionnaireConfigsQueryControllerListConfigs>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListQuestionnaireConfigsQueryControllerListConfigsQueryOptions(
      nurseryId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a questionnaire config
 */
export const updateQuestionnaireConfigCommandControllerUpdateConfig = (
  nurseryId: string,
  configId: string,
  updateQuestionnaireConfigDto: UpdateQuestionnaireConfigDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/questionnaire-configs/${configId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateQuestionnaireConfigDto,
    signal,
  });
};

export const getUpdateQuestionnaireConfigCommandControllerUpdateConfigMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateQuestionnaireConfigCommandControllerUpdateConfig
        >
      >,
      TError,
      {
        nurseryId: string;
        configId: string;
        data: UpdateQuestionnaireConfigDto;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateQuestionnaireConfigCommandControllerUpdateConfig>
    >,
    TError,
    { nurseryId: string; configId: string; data: UpdateQuestionnaireConfigDto },
    TContext
  > => {
    const mutationKey = [
      "updateQuestionnaireConfigCommandControllerUpdateConfig",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateQuestionnaireConfigCommandControllerUpdateConfig
        >
      >,
      {
        nurseryId: string;
        configId: string;
        data: UpdateQuestionnaireConfigDto;
      }
    > = (props) => {
      const { nurseryId, configId, data } = props ?? {};

      return updateQuestionnaireConfigCommandControllerUpdateConfig(
        nurseryId,
        configId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateQuestionnaireConfigCommandControllerUpdateConfigMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateQuestionnaireConfigCommandControllerUpdateConfig>
    >
  >;
export type UpdateQuestionnaireConfigCommandControllerUpdateConfigMutationBody =
  UpdateQuestionnaireConfigDto;
export type UpdateQuestionnaireConfigCommandControllerUpdateConfigMutationError =
  unknown;

/**
 * @summary Update a questionnaire config
 */
export const useUpdateQuestionnaireConfigCommandControllerUpdateConfig = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateQuestionnaireConfigCommandControllerUpdateConfig
        >
      >,
      TError,
      {
        nurseryId: string;
        configId: string;
        data: UpdateQuestionnaireConfigDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateQuestionnaireConfigCommandControllerUpdateConfig>
  >,
  TError,
  { nurseryId: string; configId: string; data: UpdateQuestionnaireConfigDto },
  TContext
> => {
  return useMutation(
    getUpdateQuestionnaireConfigCommandControllerUpdateConfigMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * @summary Remove a questionnaire config from a nursery
 */
export const removeQuestionnaireConfigCommandControllerRemoveConfig = (
  nurseryId: string,
  configId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/questionnaire-configs/${configId}`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveQuestionnaireConfigCommandControllerRemoveConfigMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeQuestionnaireConfigCommandControllerRemoveConfig
        >
      >,
      TError,
      { nurseryId: string; configId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof removeQuestionnaireConfigCommandControllerRemoveConfig>
    >,
    TError,
    { nurseryId: string; configId: string },
    TContext
  > => {
    const mutationKey = [
      "removeQuestionnaireConfigCommandControllerRemoveConfig",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeQuestionnaireConfigCommandControllerRemoveConfig
        >
      >,
      { nurseryId: string; configId: string }
    > = (props) => {
      const { nurseryId, configId } = props ?? {};

      return removeQuestionnaireConfigCommandControllerRemoveConfig(
        nurseryId,
        configId,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveQuestionnaireConfigCommandControllerRemoveConfigMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof removeQuestionnaireConfigCommandControllerRemoveConfig>
    >
  >;

export type RemoveQuestionnaireConfigCommandControllerRemoveConfigMutationError =
  unknown;

/**
 * @summary Remove a questionnaire config from a nursery
 */
export const useRemoveQuestionnaireConfigCommandControllerRemoveConfig = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeQuestionnaireConfigCommandControllerRemoveConfig
        >
      >,
      TError,
      { nurseryId: string; configId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof removeQuestionnaireConfigCommandControllerRemoveConfig>
  >,
  TError,
  { nurseryId: string; configId: string },
  TContext
> => {
  return useMutation(
    getRemoveQuestionnaireConfigCommandControllerRemoveConfigMutationOptions(
      options,
    ),
    queryClient,
  );
};
